<template>
  <div>
    <div class="tabbelong">
      <Card style="height:40px;">
        <Row>
          <i-col :span="14">
            <Input
              suffix="ios-search"
              v-model="keyword"
              @on-search="searchhand()"
              search
              placeholder="请输入测点关键字"
              style="width: auto;margin-top:-13px;"
            />
          </i-col>
        </Row>
      </Card>
      <Card style="margin-top:5px;">
        <div style="margin-top:5px;">
          <Button type="success" style="margin-right:10px;" @click="editMore()">批量导入</Button>
          <Button type="error" @click="delData('deletePointById')">批量删除</Button>
        </div>
        <Table
          border
          class="tabbottom"
          :columns="columns"
          :data="list"
          @on-selection-change="changeSelection"
        >
          <template slot-scope="{ row, index }" slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" @click="edios(row)">编辑</Button>
            <Button type="error" size="small" @click="remove(row)">删除</Button>
          </template>
        </Table>
        <div style="text-align:center">
          <Page
            class="pageBox"
            style="margin-top: 30px;text-align: center"
            :total="totalCount"
            :current="currPage"
            :page-size="limit"
            @on-change="changePage"
          ></Page>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import $pxios from "@/prjapiall/pointapi";
import { global } from "../../globals/global";
export default {
  data() {
    return {
      path: [],
      limit: 10,
      list: [],
      showDrawer: false,
      editMoreArr: [],
      styles: {
        // width:'600px',
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      selectionId: [],
      keyword: "",
      chose: "搜索测点",
      pageSize: "",
      totalCount: 10,
      totalPage: 10,
      currPage: 1,
      columns: [
        {
          title: "状态",
          type: "selection",
          align: "center",
          width:65
        },
        {
          title: "测点名称",
          key: "pntName"
        },
        {
          title: "id",
          key: "id"
        },
        {
          title: "测点编号",
          key: "pntNum"
        },
        {
          title: "安装地址",
          key: "address",
          render(h, params) {
            return h("span", params.address ? params.address : "无");
          }
        },
        {
          title: "通道",
          key: "channel",
          render(h, params) {
            return h("span", params.channel ? params.channel : "无");
          }
        },
        {
          title: "操作",
          slot: "action"
        }
      ]
    };
  },
  methods: {
    showwhat($event) {
      if ($event == "测点属性") {
        this.$router.push({
          name: "point_attr"
        });
      }
      if ($event == "初始值") {
        this.$router.push({
          name: "3D_diagram"
        });
      }
    },
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },

    changePage(val) {
      this.currPage = val;
    },
    searchhand() {
      if (this.keyword) {
        let self = this;
        $pxios("POST", "fuzzyQueryPointList", {
          keyword: this.keyword
        }).then(({ data }) => {
          if (data.code == 0) {
            const {
              pageSize,
              totalCount,
              totalPage,
              currPage,
              list
            } = data.page;
            if (list.length) {
              for (let k in data.page) {
                this[k] = data.page[k];
              }
              this.$Message.info("搜索成功");
            } else {
              this.$Message.info("未匹配到对应条件~~");
            }
          }
        });
      }
    },

    editMore() {
      this.$router.push({
        name: "new_more_point"
      });
    },
    remove(row) {
      this.$Modal.confirm({
        render: h => {
          return h("span", "确定要删除吗这一项吗");
        },
        onOk: () => {
          this.delData("deletePointById", row.id);
        }
      });
    },
    initthings() {
      $pxios("POST", "queryPointByFilter", {
        page: this.currPage + ""
      }).then(({ data }) => {
        if (data.code == 0) {
          const { totalCount, totalPage, currPage, list } = data.page;
          for (let k in data.page) {
            this[k] = data.page[k];
          }
          // conaole.log(k)
        }
      });
    },
    delData(e, id) {
      let ids = [];
      if (id) {
        // 删除一个
        ids.push(id);
        $pxios("POST", e, ids).then(({ data }) => {
          if (data.code == 0) {
            this.$Message.info("删除成功");
            this.initthings();
            this.path = [];
            this.path.push(localStorage.getItem("clientId"));
            global.$emit("position", this.path);
          } else {
            this.$Message.error(data.msg);
          }
        });
      } else {
        // 删除选中的所有
        if (this.selectionId.length > 0) {
          ids = this.selectionId;
          this.$Modal.confirm({
            render: h => {
              return h("span", "确定要批量删除吗");
            },
            onOk: () => {
              $pxios("POST", e, ids).then(({ data }) => {
                if (data.code == 0) {
                  this.$Message.info("删除成功");
                  this.initthings();
                  this.path = [];
                  this.path.push(localStorage.getItem("clientId"));
                  global.$emit("position", this.path);
                } else {
                  this.$Message.error(data.msg);
                }
              });
            }
          });
        } else {
          this.$Message.error("没有要删除的角色");
        }
      }
    },
    edios(row) {
      this.path = []
      // if(row.directory.parentId == 0){
        this.path.push(
          row.clientId,
          row.resType,
          row.id,
        );
      // }else{
      //   this.path.push(
      //     row.clientId,
      //     row.resType,
      //     row.id,
      //     1
      //   );     
      // }
      global.$emit("position", this.path);
      this.$router.push({
        name: "point_attr",
        query: {
          ...row,
          pointid: row.id
        }
      });
    }
  },
  watch: {
    currPage() {
      this.initthings();
    },
    keyword() {
      !this.keyword ? this.initthings() : this.searchhand();
    }
  },
  mounted() {
    this.keyword = this.$route.query.keyword;
    if (this.keyword === undefined) {
      this.initthings();
    } else {
      this.searchhand();
    }
  }
};
</script>

<style lang="less" scoped>
.searchea {
  display: flex;
  margin-bottom: 30px;
  margin-left: 30px;
  span {
    text-align: center;
    line-height: 30px;
  }
}
.tabbottom {
  margin-top: 10px;
}
// .tabbelong {
//   margin-left: 30px;
//   // margin-top: 40px;
//   h4 {
//     color: #979797;
//     font-weight: normal;
//     text-shadow: 2px 2px 2px white;
//   }
// }
table {
  border-collapse: collapse;
}
th td {
  /* border-radius: 2px; */
  padding: 2px;
  box-sizing: border-box;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  width: 120px;
  text-align: center;
}
td p {
  border-bottom: 2px solid #969292;
  border-right: 2px solid #969292;
  text-align: center;
  font-size: 24px;
  height: 40px;
  box-sizing: border-box;
}
th {
  background: rgba(74, 158, 238, 0.904);
  color: white;
  border-left: 1px solid #969292;
  border-bottom: 1px solid #969292;
  height: 40px;
  box-sizing: border-box;
}
input {
  text-align: center;
  height: 40px;
  width: 120px;
}
input:hover {
  background: rgb(250, 211, 154);
}
.btn {
  float: right;
  margin-right: 400px;
}
.ivu-layout-sider {
  min-height: 500px;
  background: #f5f7f9;
  // border: 1px solid #e8eaec;
  // margin-right: 10px;
}
</style>